
import { PropType, defineComponent } from 'vue';
import { AvailableLoan } from '@/interfaces/loan';
import Alert from '~/components/Alerts/Alert.vue';
import applicationId from '@/filters/application-id';
import CollectionAgencyContact from '@/components/Loans/Collections/CollectionAgencyContact.vue';

export default defineComponent({
  name: 'CollectionAlert',

  components: { CollectionAgencyContact, Alert },

  props: {
    loan: { type: Object as PropType<AvailableLoan>, required: true },
  },

  data: () => ({
    showCollectionAgencyInfo: false,
    showSelf: true,
  }),

  computed: {

    humanLoanNumber(): string {
      return applicationId(this.loan.loan_number);
    },

    isActiveLoan(): boolean {
      return this.$store.getters['User/activeLoanNumber'] === this.loan.loan_number;
    },

    hasCollectionAgencyInfo(): boolean {
      return this.loan.collection.collections_agency !== null;
    },

    isVisible(): boolean {
      if (this.isActiveLoan) {
        return true;
      }

      return this.showSelf;
    }
  },

  methods: {
    toggleInfo() {
      this.showCollectionAgencyInfo = !this.showCollectionAgencyInfo;
    }
  }
});
